import * as React from 'react';
import * as autoBind from 'react-autobind';
import {Glyphs} from '@techsmith/tsc-cloud-style-guide';
import Strings from '../../globals/Strings';
import {AnnotationModes} from '../../globals/Constants';
import {MobileViewingModes} from '../../globals/Constants';

export default class AddCommentIcon extends React.Component<AddCommentIconProps, {}> {
   constructor(props: AddCommentIconProps) {
      super(props);
      autoBind(this);
   }

   componentDidMount() {
      this.props.setAnnotationMode(AnnotationModes.none);
   }

   onClick(e: any) {
      const {setMobileViewingMode, pausePlayer} = this.props;
      pausePlayer();
      setMobileViewingMode(MobileViewingModes.feedback);
   }

   render() {
      const {mobileViewingMode} = this.props;

      return (
          <div className="add-comment-icon-wrapper">
            {mobileViewingMode === MobileViewingModes.conversation && <button className="clear-button-default-stlying add-comment-icon" onClick={this.onClick} aria-label={Strings.accessibility.mobileAddCommentIconLabel}>
                <Glyphs.Add24x24 className="add-comment-glyph" tabIndex={-1}/>
             </button>
            }
          </div>
      );
   }
}

export interface AddCommentIconProps {
   annotationMode: AnnotationModes;
   mobileViewingMode: MobileViewingModes;
   pausePlayer(): void;
   setMobileViewingMode(mobileViewingMode: MobileViewingModes): void;
   setAnnotationMode(annotationMode: AnnotationModes): void;
}